import { DialogOverlay, DialogWrapper } from './styles';
export type AmpDialogProps = React.PropsWithChildren<{
  open: boolean;
  onClose: () => void;
}>;

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const AmpDialog: React.FC<AmpDialogProps> = (props) => {
  const { open, onClose, children } = props;

  // ======================= HOOKS

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS

  // ======================= VIEWS
  if (!open) return null;
  return (
    <DialogOverlay onClick={onClose}>
      <DialogWrapper onClick={(e) => e.stopPropagation()}>
        {children}
      </DialogWrapper>
    </DialogOverlay>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default AmpDialog;
